/* lua.js generated code 0.3.0 */

let PreloadScene = require('./PreloadScene.js')

// 不需要真的加载这个场景
let PreloadSceneHtml = xClass("PreloadSceneHtml", PreloadScene)

    PreloadSceneHtml.create = function() {
        var s = PreloadSceneHtml.new()
        s.initScene()
        s.name = "PreloadScene"
        s.show()
        return s
    },

    PreloadSceneHtml.prototype.run = function() {}

    PreloadSceneHtml.prototype.show = function() {
        this.preloader = document.getElementById('preloader')
        this.preloader.style.visibility = 'visible'
        var splash = document.getElementById('splash')
        splash && splash.remove()
    },

    PreloadSceneHtml.prototype.initBg = function (onBgInitedCallback) {
        setTimeout(onBgInitedCallback, 0);
    }

    PreloadSceneHtml.prototype.initTip = function () {
        this.tips = document.querySelector('.progress-tips')
        if (this.tips) {
            this.tips.innerText = this.isOldUserLocal() ? PreloadScene.tipsText[1] : PreloadScene.tipsText[0]
        }
    }
    PreloadSceneHtml.prototype.initProgress = function() {
        this.progress = document.querySelector('.progress')
        this.progressValue = document.querySelector('.progress-value')
    },

    PreloadSceneHtml.prototype.updateProgressBar = function(percent) {
        let value = percent ? Math.floor(percent * 100) + '%' : ''
        this.progress.style.width = value
        this.progressValue.innerText = value
    },

    PreloadSceneHtml.prototype.gotoNextScene = function() {
        PreloadScene.prototype.gotoNextScene.call(this)
        this.cleanup()
    }

    PreloadSceneHtml.prototype.cleanup = function() {
        setTimeout(() => {
            this.preloader && this.preloader.remove()
        }, 0)
    }

module.exports = PreloadSceneHtml